import React from "react";
import "./target.scss";
// import InnerShadowButton from "../../common/buttons/innerShadow";

function Target() {
  return (
    <div className=" d-flex target-container">
      <img
        className="section-img"
        src={require("../../../assets/images/landing/headset-image.png")}
        alt=""
      />
      <div lg="6" className="m-0 p-0 right-col text-left">
        <h2 className="title opacity-90">One Friendly Call Away</h2>
        <h3 className="sub-title">
          Be it any dilemma regarding the policy or any query when it comes to
          claims, our customer service team is literally just a call away (Did
          we tell you that it’s a Toll Free number)
        </h3>
        <div className="call-btn">
          <a href="tel:+919389938938">
            <img
              src={require("../../../assets/images/icons/call-white.png")}
              alt=""
            />{" "}
            +91-9389-9389-38
          </a>
        </div>
      </div>
    </div>
  );
}

export default Target;
